import useAppSelector from '@/hooks/useAppSelector'
import { selectIsCompanyUser } from '@/redux/slices/session'

export function useIsCompanyUser() {
  return useAppSelector(selectIsCompanyUser)
}
